<template>
  <div>
    <TrackerPanelTemperature></TrackerPanelTemperature>
  </div>
</template>


<script>
import TrackerPanelTemperature from "./TrackerPanelTemperature"
import {HTTP, PUB_HTTP} from '../http-constants'
import {bus} from "@/event-bus";
import * as nvxlib from "@/nvxcommon";
import DevicesListSideBar from "@/components/DevicesListSideBar";
import DeviceLinksBar from "@/components/DeviceLinksBar";
import TrackerPanelInfo from "@/components/TrackerPanelInfo";
import TrackerPanelShare from "@/components/TrackerPanelShare";
import TrackerPanelEdit from "@/components/TrackerPanelEdit";
import TrackerPanelActivity from "@/components/TrackerPanelActivity";

export default {
  data() {
    return {
      devices:[],
    }
  },
  delimiters: ['${', '}'],
  components: {
    TrackerPanelTemperature
  },
  methods: {
  },
  async mounted() {
    let self = this;
    console.log("created")
    let parameters = this.$route.query;
    if (parameters['token']) {
      let token = parameters['token'];
      self.$store.commit('updateToken', token);
      HTTP.defaults.headers.common['Authorization'] = "Bearer " + token;
    }

    if (parameters['serial']) {

      nvxlib.getDevices(function (devices) {
        if (devices.length) {
          self.devices = devices;
          let tracker = self.devices.filter(device => device.serial == parameters['serial'])[0];
          bus.$emit('tracker_panel', {action: 'temperature', tracker: tracker});
        }
      });
    }
}
}
</script>